import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectLoading } from 'services/loading/selectors';

import { AppState } from 'services/types';

export interface OwnProps {
    children?: React.ReactElement | React.ReactElement[];
    LoadingComponent?: React.ReactElement;
    namespace: string;
}

interface StateProps {
    loading?: boolean;
}

type Props = StateProps & OwnProps;

export class LoadingGate extends React.PureComponent<Props> {
    static defaultProps = {
        loading: true
    };

    render(): React.ReactElement | React.ReactElement[] | null {
        const { children, loading, LoadingComponent } = this.props;
        if (loading) {
            return LoadingComponent || null;
        }

        return children || null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    StateProps
>({
    loading: makeSelectLoading()
});

export default connect(mapStateToProps)(LoadingGate);
